// Modules
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { AppConfigService } from '@shared-module/services/app-config/app-config.service';

// Interfaces
import { IDashboardGetAutoStatisticsRequest } from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  // Private variables
  private _baseUrl: string;

  // Constructor
  constructor(
    private _app: AppConfigService,
    private _httpClient: HttpClient
  ) {}

  // Private method to set the base url
  private _setBaseUrl(): void {
    if (!this._baseUrl)
      this._baseUrl = `${this._app.carInsuranceConfig.backendBaseUrl}/chart/quote`;
  }

  // Public method to get dashboard auto statistics
  public getDashboardAutoStatistics(
    body: IDashboardGetAutoStatisticsRequest
  ): Observable<any> {
    this._setBaseUrl();
    const dashboardStatisticsPath = this._baseUrl;
    return this._httpClient.post(dashboardStatisticsPath, body);
  }
}
